"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exists = exports.isNotNullish = void 0;
function isNotNullish(value) {
    return value !== undefined && value !== null;
}
exports.isNotNullish = isNotNullish;
function exists(value) {
    return value === (value !== null && value !== void 0 ? value : !value);
}
exports.exists = exists;
//# sourceMappingURL=typeGuards.js.map